import React from 'react';
import styles from './index.module.scss';

const ImageWithContentCard = ({
    mainTitle,
    orientation,
    body,
    fullWidth = false,
}) => {
    const { image, content } = body || {};
    const { heading, description } = content || {};
    const { li, paragraphs, careTip } = description || {};

    return (
        <div className={styles.wrapper}>
            {mainTitle?.text && (
                <section className="c-koh-simple-content v-koh-snippet">
                    <div className="koh-simple-content-container">
                        <h1 className="koh-simple-content-title">
                            {mainTitle.text}
                        </h1>
                    </div>
                </section>
            )}

            {body && (
                <section
                    className={`c-koh-simple-content v-koh-snippet
                        ${orientation ? `m-koh-image-${orientation}` : ''}
                        ${fullWidth ? 'm-koh-wrap-content' : ''}
                    `}
                >
                    {/* IMAGE */}
                    {image?.src && (
                        <div className="koh-simple-content-image">
                            <img
                                src={image.src}
                                style={{ width: `${image?.width ?? 400}px`, height: `${image?.height ?? 290}px` }}
                                alt={image.alt}
                            />
                        </div>
                    )}

                    {/* ✅ HEADING OUTSIDE (IMPORTANT) */}
                    {heading?.text && (
                        <h2 className="koh-simple-content-title">
                            {heading.text}
                        </h2>
                    )}

                    {/* ✅ BODY DIRECTLY AFTER IMAGE (NO CONTAINER BLOCKING) */}
                    <div className="koh-simple-content-body">
                        {li?.length > 0 && (
                            <ul>
                                {li.map((item, index) =>
                                    item.text && (
                                        <li key={index}>{item.text}</li>
                                    )
                                )}
                            </ul>
                        )}

                        {paragraphs?.length > 0 &&
                            paragraphs.map(
                                (text, index) =>
                                    text && <p key={index}>{text}</p>
                            )}

                        {careTip && (
                            <p>
                                <strong>Care Tip</strong>
                                <br />
                                {careTip}
                            </p>
                        )}
                    </div>
                </section>
            )}
        </div>
    );
};

export default ImageWithContentCard;